import React, { useEffect, useState } from "react";
import image from "../../../assets/kangaroo/AboutBanner.png";
import btn from "../../../assets/kangaroo/applybtn.svg";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import { hover, motion } from "framer-motion";
import "../CareerPage.css";
import { jobs } from "../data.js";
import { Upload } from "lucide-react";
import Button from "../../../component/button/Button.jsx";
import { Col, Progress, Row } from "reactstrap";
import MediumButton from "../../../component/button/MediumButton.jsx";
import InlineForm from "../../../component/InlineForm/InlineForm.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm.jsx";
import PageService from "../../../services/PageService.js";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi.js";
import JobListService from "../../../services/Joblist.js";
import { formatDate } from "../../../common/formatedate.js";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import JobApplicationService from "../../../services/JobApplicationService.js";
import nepal from "../../../assets/kangaroo/nepalflag.png";
import Smallbutton from "../../../component/button/Smallbutton.jsx";
import FormClose from "../../../component/FormClose/FormClose.jsx";
import Dropdown from "../../../component/dropdown/Dropdown.jsx";
import country from "../../../common/data/country.jsx";

const CareerLanding = () => {
  const router = useNavigate();
  const location = useLocation();
  const path = location.pathname.replace(/^\/+/, "").split("/").pop();

  const [countryCode, setCountryCode] = useState({
    id: 6,
    label: "+977",
    flag: nepal,
  });
  const [thankYouModal, setThankYouModal] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [phoneNumber, setphoneNumber] = useState("");
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const fetchData = async () => {
    const response = await PageService.getbySlug(path);
    return response;
  };

  const fetchJobData = async () => {
    const response = await JobListService.getList();
    return response;
  };

  const {
    isPending: isPendingJob,
    error: errorJob,
    data: jobData,
  } = useQuery({
    queryKey: ["jobData", path],
    queryFn: fetchJobData,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
    };

    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    email: Yup.string()
      .trim()
      .required("Email address is required")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Please enter a valid email address"
      )
      .max(254, "Email address is too long"),

    permanentAddress: Yup.string().required("Address is required"),
    phoneNumber: Yup.string()
      .transform((value) => (value ? String(value) : "")) // ensure it's a string
      .matches(/^[0-9]+$/, "Phone number must contain only numbers") // no letters/special chars
      .min(10, "Phone number must be at least 10 digits") // minimum 10 digits
      .required("Phone number is required"),
    countryCode: Yup.string().required("Country Code is required"),
    interestedPosition: Yup.string().required(
      "Interested Position is required"
    ),
    cv: Yup.mixed()
      .required("CV is required")
      .test("fileType", "Only PDF files are allowed", (value) => {
        return value && value.type === "application/pdf";
      }),
  });

  const handleCustomSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Create FormData for multipart/form-data
      console.log("called");
      toggleThankYou();
      const formData = new FormData();
      formData.append("fullName", values.fullName);
      formData.append("email", values.email);
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("countryCode", values.countryCode);
      formData.append("interestedPosition", values.interestedPosition);
      formData.append("permanentAddress", values.permanentAddress);
      formData.append("message", values.message);
      formData.append("jobListingId", values.id || "");
      formData.append("submittedAt", new Date().toISOString());

      // Append the CV file
      if (values.cv) {
        formData.append("resumeUrl", values.cv);
      }

      console.log("\n--- FormData Contents ---");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(
            `${key}:`,
            `[File: ${value.name}, ${(value.size / 1024).toFixed(2)} KB]`
          );
        } else {
          console.log(`${key}:`, value);
        }
      }

      // Send to API
      console.log("\n--- Sending to API ---");
      const response = await JobApplicationService.create(formData);

      console.log("\n--- API Response ---");
      console.log("Response:", response);

      console.log("\n=== FORM SUBMISSION COMPLETED SUCCESSFULLY ===");

      // Reset form after successful submission
      resetForm();
      setCountryCode({ id: 6, label: "+977", flag: nepal });
      setSelectedLevel(null);
      setSelectedPosition(null);
    } catch (error) {
      console.error("\n=== FORM SUBMISSION ERROR ===");
      console.error("Error Message:", error.message);
      console.error("Error Details:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const {
    isPending,
    error,
    data: pageData,
  } = useQuery({
    queryKey: ["pageData", path],
    queryFn: fetchData,
  });

  // Filter out jobs with negative daysLeft
  const activeJobs = jobData?.items?.filter((job) => job.daysLeft >= 0) || [];

  return (
    <>
      <div
        className="hero-banner"
        style={{
          "--banner-img": `url(${imageBaseApi + pageData?.featuredMedia?.url})`, marginBottom: "5.5rem"
        }}
      >
        <SectionContainer>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "CORPORATE", link: "/" },
              { title: "CAREER" },
            ]}
            instituition={true}
          />
          <div className=" w-100 d-flex justify-content-start align-items-center">
            <h1 className="font-level-4 lh-1">
              FIND YOUR <br /> OPPORTUNITY{" "}
            </h1>
          </div>
        </SectionContainer>
      </div>

      {activeJobs.length > 0 ? (
        <>
          <SectionContainer>
            <h1
              className="career-sub-heading lh-1 pb-4"

            >
              Current Job Openings
            </h1>
            <Row className="gy-4  " style={{ marginBottom: "13rem" }}>
              {activeJobs.map((data, index) => {
                // Assuming you have a total duration - adjust this logic based on your needs
                const totalDays = 30;
                const progressValue =
                  ((totalDays - data.daysLeft) / totalDays) * 100;

                return (
                  <Col lg={12} key={index}>
                    <div className="d-flex flex-column align-items-start p-5 mb-4 rounded-5 border">
                      <h1 className="font-level-8">{data.position}</h1>
                      <p className="career-desc-font">
                        Position(s):{" "}
                        <span className="career-desc-font fw-bold">
                          {data.slotsLeft}
                        </span>
                      </p>
                      <p className="career-desc-font">
                        Published Date:{" "}
                        <span className="career-desc-font fw-bold">
                          {formatDate(data.publishedDate)}
                        </span>
                      </p>
                      <p
                        className="career-desc-font"
                        style={{ marginBottom: "2rem" }}
                      >
                        Deadline:{" "}
                        <span className="career-desc-font fw-bold">
                          {formatDate(data.deadLine)}
                        </span>
                      </p>

                      <Progress
                        value={progressValue}
                        className="mb-3 custom-progress"
                        style={{ height: "10px", width: "100%" }}
                      />

                      <p
                        className="country-paragraph-text"
                        style={{ marginBottom: "2rem" }}
                      >
                        {data.daysLeft} Day(s) left
                      </p>

                      <Row>
                        <Col lg={6} sm={12}>
                          <div className="d-flex align-items-center mb-4">
                            <motion.button
                              className="rounded-pill font-level-2"
                              style={{
                                whiteSpace: "nowrap",
                                height: "70px",
                                width: "235px",
                                border: "none",
                                boxShadow: "0 0 0 1px #687c8694",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer",
                                background: "white",
                              }}
                              onClick={() =>
                                router(
                                  `/corporate/career/${data?.id}?ref=${imageBaseApi + pageData?.featuredMedia?.url
                                  })`
                                )
                              }
                              whileHover="hover"
                            >
                              <motion.div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  left: 0,
                                  background:
                                    "linear-gradient(to right, #81168F, #D50A84)",
                                  zIndex: 0,
                                }}
                                initial={{ x: "-100%" }}
                                variants={{
                                  hover: { x: 0 },
                                }}
                                transition={{
                                  duration: 0.5,
                                  ease: "easeInOut",
                                }}
                              />
                              <motion.span
                                style={{ position: "relative", zIndex: 1 }}
                                initial={{ color: "#000" }}
                                variants={{
                                  hover: {
                                    color: "#fff",
                                    transition: {
                                      duration: 0.5,
                                    },
                                  },
                                }}
                              >
                                VIEW DETAILS
                              </motion.span>
                            </motion.button>
                          </div>
                        </Col>
                        <Col
                          lg={6}
                          sm={12}
                          onClick={() =>
                            router(
                              `/corporate/career/${data?.id}?ref=${imageBaseApi + pageData?.featuredMedia?.url
                              })`
                            )
                          }
                        >
                          {!isMobile ? (
                            <MediumButton
                              label="Apply Now"
                              fill="#FFFF"
                              textColor="#7E1790"
                              career={true}
                            />
                          ) : (
                            <Smallbutton text="Apply Now" width="400px" />
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </SectionContainer>

          <SectionContainer mainId="careerpage">
            <Row style={{ marginTop: "0rem" }}>
              <Col>
                <h1 className="font-heading">
                  Looking For Future Opportunities
                </h1>
                <p className="country-paragraph-text mt-3 mb-0 ">
                  If none of the current openings match your profile, fill in
                  your details below, and we'll reach out when a suitable
                  opportunity comes up.
                </p>
              </Col>
            </Row>

            <Formik
              initialValues={{
                fullName: "",
                permanentAddress: "",
                email: "",
                phoneNumber: "",
                countryCode: "+977",
                interestedPosition: "",
                cv: null,
                message: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleCustomSubmit}
            >
              {({
                setFieldValue,
                values,
                handleSubmit,
                isSubmitting,
                touched,
                errors,
                handleChange,
                handleBlur,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={6} sm={12}>
                      <div>
                        <label htmlFor="fullName" className="font-label">
                          Full Name*
                        </label>
                        <Field
                          type="text"
                          className="form-control form-box py-3"
                          id="fullName"
                          name="fullName"
                        />
                        <ErrorMessage
                          name="fullName"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    <Col lg={6} sm={12}>
                      <div>
                        <label
                          htmlFor="permanentAddress"
                          className="font-label"
                        >
                          Address*
                        </label>
                        <Field
                          type="text"
                          className="form-control form-box py-3"
                          id="permanentAddress"
                          name="permanentAddress"
                        />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    <Col lg={6} sm={12}>
                      <div>
                        <label htmlFor="email" className="font-label">
                          Email Address*
                        </label>
                        <Field
                          type="email"
                          className="form-control form-box py-3"
                          id="email"
                          name="email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    <Col sm={12} lg={6}>
                      <div>
                        <label htmlFor="phoneNumber" className="font-label">
                          Phone Number*
                        </label>
                        <div
                          className="d-flex justify-content-center align-items-start position-relative"
                          style={{
                            borderRadius: "8px",
                            transition: "box-shadow 0.2s ease-in-out",
                            border:
                              errors.phoneNumber || errors.countryCode
                                ? ""
                                : "none", // highlight border if error
                          }}
                          onFocus={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 0 0 4px rgba(13, 110, 253, 0.25)";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div style={{ flex: "0 0 6rem" }}>
                            <Dropdown
                              items={country.map((item) => ({
                                id: item.id,
                                label: item.countryCode,
                                flag: item.flagImg,
                              }))}
                              width="9rem"
                              selectedItem={countryCode}
                              setSelectedItem={(item) => {
                                setCountryCode(item);
                                setFieldValue(
                                  "countryCode",
                                  item?.label || null
                                );
                              }}
                              phoneNumber={true}
                              placeholder="+977"
                              placeholderFlag={nepal}
                            />
                          </div>
                          <div style={{ flex: 1 }}>
                            <Field
                              type="number"
                              name="phoneNumber"
                              value={values.phoneNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="form-control form-box py-3"
                              style={{
                                borderLeft: "0",
                                borderTop: "2px solid #687C86",
                                borderRight: "2px solid #687C86",
                                borderBottom: "2px solid #687C86",
                                borderTopRightRadius: "8px",
                                borderBottomRightRadius: "8px",
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                                boxSizing: "border-box",
                                paddingLeft: "12px",
                                width: "100%",
                                outline: "none",
                                boxShadow: "none",
                              }}
                            />
                          </div>
                        </div>

                        {/* Show error for the whole component */}
                        {(touched.phoneNumber && errors.phoneNumber) ||
                          (touched.countryCode && errors.countryCode) ? (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {touched.countryCode && errors.countryCode
                              ? errors.countryCode
                              : touched.phoneNumber && errors.phoneNumber
                                ? errors.phoneNumber
                                : null}
                          </div>
                        ) : null}
                      </div>
                    </Col>

                    <Col lg={6} sm={12}>
                      <div>
                        <label
                          htmlFor="interestedPosition"
                          className="font-label"
                        >
                          Interested Position*
                        </label>

                        {/* <Dropdown
                        items={[
                          { id: 1, label: "Software Engineer" },
                          { id: 2, label: "Data Engineer" },
                          { id: 3, label: "Data Scientist" },
                        ]}
                        selectedItem={selectedPosition}
                        setSelectedItem={(item) => {
                          setSelectedPosition(item);
                          setFieldValue("interestedPosition", item?.label || "");
                        }}
                        placeholder=" "
                      /> */}

                        <Field
                          type="text"
                          name="interestedPosition"
                          className={`form-control form-box py-3 ${touched.interestedPosition &&
                              errors.interestedPosition
                              ? "is-invalid"
                              : ""
                            }`}
                          id="interestedPosition"
                        />

                        <ErrorMessage
                          name="interestedPosition"
                          component="div"
                          className="text-danger mt-1"
                          style={{ fontSize: "0.875rem" }}
                        />
                      </div>
                    </Col>

                    <Col lg={6} sm={12}>
                      <div>
                        <div
                          style={{
                            backgroundColor: "#687c86",
                            marginTop: "2.5rem",
                            cursor: "pointer",
                          }}
                          className="d-flex justify-content-start px-3 align-items-center rounded gap-3"
                          onClick={() =>
                            document.getElementById("cvUpload").click()
                          }
                        >
                          <Upload />
                          <p
                            className="career-upload-font m-0 rounded"
                            style={{
                              paddingBottom: "1.081rem",
                              paddingTop: "1.081rem",
                            }}
                          >
                            {values.cv ? values.cv.name : "Upload your CV*(only pdf)"}
                          </p>
                        </div>
                        <input
                          id="cvUpload"
                          type="file"
                          accept=".pdf"
                          style={{ display: "none" }}
                          onChange={(e) =>
                            setFieldValue("cv", e.target.files[0])
                          }
                        />
                        <ErrorMessage
                          name="cv"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    <Col sm={12}>
                      <div>
                        <label htmlFor="message" className="font-label">
                          Message (if any)
                        </label>
                        <Field
                          as="textarea"
                          name="message"
                          className={`form-control form-height form-box ${touched.message && errors.message
                              ? "is-invalid"
                              : ""
                            }`}
                          id="message"
                          rows={4}
                          style={{ resize: "vertical" }}
                        />
                        <ErrorMessage
                          name="message"
                          component="div"
                          className="text-danger mt-1"
                          style={{ fontSize: "0.875rem" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <div
                    className="d-flex justify-content-end"
                    style={{ marginBottom: "15.5rem", marginTop: "2.5rem" }}
                  >
                    <button
                      type="submit"
                      style={{ border: "none", background: "none", padding: 0 }}
                      onClick={() => {
                        console.log("Errors:", errors);
                        console.log("Values:", values);
                        console.log(
                          "Is Valid:",
                          Object.keys(errors).length === 0
                        );
                      }}
                    >
                      <Smallbutton text="APPLY" />
                    </button>
                  </div>
                </form>
              )}
            </Formik>
            <FormClose
              modal={thankYouModal}
              toggle={toggleThankYou}
              heading="THANK YOU FOR APPLYING"
              description="We have received your application and will get back to you as soon as possible."
            />
          </SectionContainer>
        </>
      ) : (
        <SectionContainer>
          <Row style={{ marginTop: "3.5rem" }}>
            <Col>
              <p className="country-paragraph-text  mb-5 ">
                We don’t have any active openings at the moment, but you can
                submit your details below to be considered for future
                opportunities.
              </p>
            </Col>
          </Row>

          <Formik
            initialValues={{
              fullName: "",
              email: "",
              phoneNumber: "",
              countryCode: "+977",
              interestedPosition: "",
              message: " ",
              cv: null,
            }}
            validationSchema={validationSchema}
            onSubmit={handleCustomSubmit}
          >
            {({
              setFieldValue,
              values,
              handleSubmit,
              isSubmitting,
              touched,
              errors,
              handleChange,
              handleBlur,
            }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={6} sm={12}>
                    <div>
                      <label htmlFor="fullName" className="font-label">
                        Full Name*
                      </label>
                      <Field
                        type="text"
                        className="form-control form-box py-3"
                        id="fullName"
                        name="fullName"
                      />
                      <ErrorMessage
                        name="fullName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col lg={6} sm={12}>
                    <div>
                      <label htmlFor="permanentAddress" className="font-label">
                        Address*
                      </label>
                      <Field
                        type="text"
                        className="form-control form-box py-3"
                        id="permanentAddress"
                        name="permanentAddress"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>

                  <Col lg={6} sm={12}>
                    <div>
                      <label htmlFor="email" className="font-label">
                        Email Address*
                      </label>
                      <Field
                        type="email"
                        className="form-control form-box py-3"
                        id="email"
                        name="email"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>

                  <Col sm={12} lg={6}>
                    <div>
                      <label htmlFor="phoneNumber" className="font-label">
                        Phone Number*
                      </label>
                      <div
                        className="d-flex justify-content-center align-items-start position-relative"
                        style={{
                          borderRadius: "8px",
                          transition: "box-shadow 0.2s ease-in-out",
                          border:
                            errors.phoneNumber || errors.countryCode
                              ? ""
                              : "none", // highlight border if error
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 0 0 4px rgba(13, 110, 253, 0.25)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div style={{ flex: "0 0 6rem" }}>
                          <Dropdown
                            items={country.map((item) => ({
                              id: item.id,
                              label: item.countryCode,
                              flag: item.flagImg,
                            }))}
                            width="9rem"
                            selectedItem={countryCode}
                            setSelectedItem={(item) => {
                              setCountryCode(item);
                              setFieldValue("countryCode", item?.label || null);
                            }}
                            phoneNumber={true}
                            placeholder="+977"
                            placeholderFlag={nepal}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Field
                            type="number"
                            name="phoneNumber"
                            value={values.phoneNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control form-box py-3"
                            style={{
                              borderLeft: "0",
                              borderTop: "2px solid #687C86",
                              borderRight: "2px solid #687C86",
                              borderBottom: "2px solid #687C86",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              borderTopLeftRadius: "0",
                              borderBottomLeftRadius: "0",
                              boxSizing: "border-box",
                              paddingLeft: "12px",
                              width: "100%",
                              outline: "none",
                              boxShadow: "none",
                            }}
                          />
                        </div>
                      </div>

                      {/* Show error for the whole component */}
                      {(errors.phoneNumber || errors.countryCode) && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {errors.countryCode
                            ? errors.countryCode
                            : errors.phoneNumber}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col sm={12} lg={6}>
                    <div>
                      <label
                        htmlFor="interestedPosition"
                        className="font-label"
                      >
                        Interested Position*
                      </label>

                      <Field
                        type="text"
                        name="interestedPosition"
                        className={`form-control form-box py-3 ${touched.interestedPosition &&
                            errors.interestedPosition
                            ? "is-invalid"
                            : ""
                          }`}
                        id="interestedPosition"
                      />

                      {/* <Dropdown
                      items={[
                        { id: 1, label: "Software Engineer" },
                        { id: 2, label: "Data Engineer" },
                        { id: 3, label: "Data Scientist" },
                      ]}
                      selectedItem={selectedLevel}
                      setSelectedItem={(item) => {
                        setSelectedLevel(item);
                        setFieldValue("interestedPosition", item?.label || "");
                      }}
                      placeholder=" "
                    /> */}

                      <ErrorMessage
                        name="interestedPosition"
                        component="div"
                        className="text-danger mt-1"
                        style={{ fontSize: "0.875rem" }}
                      />
                    </div>
                  </Col>

                  <Col lg={6} sm={12}>
                    <div>
                      <div
                        style={{
                          backgroundColor: "#687c86",
                          marginTop: "2.5rem",
                          cursor: "pointer",
                        }}
                        className="d-flex justify-content-start px-3 align-items-center rounded gap-3"
                        onClick={() =>
                          document.getElementById("cvUpload").click()
                        }
                      >
                        <Upload />
                        <p
                          className="career-upload-font m-0 rounded"
                          style={{
                            paddingBottom: "1.081rem",
                            paddingTop: "1.081rem",
                          }}
                        >
                          {values.cv ? values.cv.name : "Upload your CV*(only pdf)"}
                        </p>
                      </div>
                      <input
                        id="cvUpload"
                        type="file"
                        accept=".pdf"
                        style={{ display: "none" }}
                        onChange={(e) => setFieldValue("cv", e.target.files[0])}
                      />
                      <ErrorMessage
                        name="cv"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} key="message">
                    <div>
                      <label htmlFor="message" className="font-label">
                        Message (if any)
                      </label>
                      <Field
                        as="textarea"
                        name="message"
                        className={`form-control form-height form-box ${touched.message && errors.message ? "is-invalid" : ""
                          }`}
                        id="message"
                        rows={4}
                        style={{ resize: "vertical" }}
                      />
                      <ErrorMessage
                        name="message"
                        component="div"
                        className="text-danger mt-1"
                        style={{ fontSize: "0.875rem" }}
                      />
                    </div>
                  </Col>
                </Row>

                <div
                  className="d-flex justify-content-end"
                  style={{ marginBottom: "15.5rem", marginTop: "2.5rem" }}
                >
                  <button
                    // type="submit"
                    className="ms-auto"
                    style={{ border: "none", background: "none", padding: 0 }}
                    disabled={isSubmitting}
                  >
                    <Smallbutton className="ms-auto" text="APPLY" />
                  </button>
                </div>
              </form>
            )}
          </Formik>
          <FormClose
            modal={thankYouModal}
            toggle={toggleThankYou}
            heading="THANK YOU FOR APPLYING"
            description="We have received your application and will get back to you as soon as possible."
          />
        </SectionContainer>
      )}
    </>
  );
};

export default CareerLanding;
